import React, { useEffect, useState } from 'react'
import BreadCrumb from '../../utilities/BreadCrumb'
import "../../creative/report/report.scss"
import { createDataReview } from '../earnings/helpers';
import { getCountryStorage, getModel, getModelName } from '../common';
import SpendingSummary from './card';
import CustomEchart from '../../echart';

function SpendReviews(props) {


    let model = getModel()
    let modelName = getModelName()
    
    const country = getCountryStorage();
    //console.log(modelName, country)
    
    useEffect(() => {
        document.getElementById("root").classList.add("root-light");

        return () => {
            document.getElementById("root").classList.remove("root-light");
        }
        // eslint-disable-next-line
    }, [props])

    const renderChart = () => {
        return <div className="mt-4 chart-container">
            <strong><h3>Spend Review</h3> </strong>
            <p className="bb-sub-header-txt mb-4">As defined in the commercials dated <mark>04/04/2025</mark>, this Spend Review provides
                a comparison between the predicted and actual spend. The variance will be aligned in the next review, scheduled for <mark>31/03/2026</mark></p>

            <div className="d-flex flex-row">
                
            <CustomEchart
                width="800px"
                height="400px"
                dataFormat="JSON"
                options={createDataReview(modelName, country)}
            />
            <SpendingSummary country={country} />
            </div>

        </div>
    }
    return (
        <>
            <BreadCrumb checkDeep={false} name={model === 2 ? "Volume Rewards" : model === 1 ? "Independent" : "Volume Discount"} />
            <div className="d-flex flex-column justify-content-center m-3  ">

                <div className="d-flex flex-column mx-4 p-3 mb-3 report-container">
                    {renderChart()}                    
                </div>
            </div>
        </>
    )
}

export default (SpendReviews);